import { EnvironmentEntry } from "@visioni/a3s-environments";
import { environments, isProductionRelease, platform } from "./build";
import { match } from "ts-pattern";

// TODO: Split into different hooks, compose them together.

/**
 * Get the build-time default environment.
 * For runtime environment (which may be changed), use getEnvironment() from environment-store.
 */
export const environment = () => environments.available[environments.default];

export const directory = (env: EnvironmentEntry) => `https://${env.fqdn}`;

/** Client-side credentials for one Amplitude project. */
export interface AmplitudeProject {
  /** Analytics API key. */
  readonly apiKey: string;
  /** Experiment (feature flag) deployment key. */
  readonly deploymentKey: string;
}

const AMPLITUDE_PROJECTS = {
  production: {
    apiKey: "927fcc00ce52c37239e3fce398432eb6",
    deploymentKey: "client-z7gZHeaUUnSEjdssXDWjrqAkzMBLCbpO",
  },
  nonProduction: {
    apiKey: "1f124cab69fbdbd4f4982d5476038685",
    deploymentKey: "client-I5ZzAeHbsj8MOU1XZW8rlcFupU6KSmzl",
  },
} as const satisfies Record<string, AmplitudeProject>;

/** The Amplitude project this build reports to. Only the production release uses production. */
export const amplitudeProject: AmplitudeProject =
  isProductionRelease ? AMPLITUDE_PROJECTS.production : AMPLITUDE_PROJECTS.nonProduction;

export const authorization = (env: EnvironmentEntry) => ({
  domain: env.authDomain,
  audience: env.authAudience,
  clientId: env.authClientId,
  // These are a contract:
  // - registered Vision Auth (complete callback path)
  //   https://gitlab.com/visioni/teams/coredev/vision-auth/-/blob/main/auth0.py
  // - web stack deployment (base path '/app')
  //   apps/a3s-cloud/lib/realm-web-stack.ts
  redirectUri: match(platform)
    .with({ kind: "web" }, () => `${window.location.origin}/app/sign-in/callback`)
    .with(
      { kind: "ios" },
      (cfg) => `${cfg.scheme}://${env.authDomain}/${cfg.kind}/${cfg.ios.bundleIdentifier}/callback`,
    )
    .with({ kind: "android" }, (cfg) => `${cfg.scheme}://${env.authDomain}/${cfg.kind}/${cfg.android.package}/callback`)
    .exhaustive(),
  discovery: {
    authorizationEndpoint: `https://${env.authDomain}/authorize`,
    tokenEndpoint: `https://${env.authDomain}/oauth/token`,
  },
});
